import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Divider,
    FormControlLabel,
    FormLabel,
    IconButton,
    Radio,
    RadioGroup,
    TextField,
    Typography,
    MenuItem,
    DialogTitle,
} from '@material-ui/core';
import {
    AddRounded,
    CancelRounded,
    DescriptionRounded,
    RemoveRounded,
    SaveRounded,
    SearchRounded,
} from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';

import { useSelector, useDispatch } from 'react-redux';
import CenterLoading from '../../../components/layout/CenterLoading';
import { getFreeVideos, getPaidVideos } from '../../../redux/actions/dataActions';
import {
    getAfterSchoolVideo,
    updateAfterSchoolVideos,
    getAfterSchoolLecture,
    updateAfterSchoolLectures,
    clearAfterSchoolVideo,
    clearAfterSchoolLecture,
} from '../../../redux/actions/adminActions';


export default function AdminAfterSchoolVideos({ open, setOpen, type = null, afterSchoolInfo = null }) {
    const { adminLoading, afterSchoolVideos, afterSchoolLectures } = useSelector((state) => state.admin);
    const { videos, freeVideos, dataLoading, dataErrors } = useSelector((state) => state.data);

    const dispatch = useDispatch();
    const [options, setOptions] = useState([]);
    const [myVideos, setMyVideos] = useState([]);
    const [myLectures, setMyLectures] = useState([]);
    const [searchOpen, setSearchOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [vId, setVId] = useState(null);
    const [typeOption, setTypeOption] = useState(type === 'certificate' ? null : '방과후');
    const [videoTypeOption, setVideoTypeOption] = useState('');

    useEffect(() => {
        if (typeOption) {
            setVId(
                typeOption === '방과후' ? 'r53cCc6vvbhKaT97wZ5O' : typeOption === '구독' ? 'dedalHbL0DPh2sNem1Z0' : null
            );
            setMyVideos([]);
        }
    }, [typeOption]);

    useEffect(() => {
        setVideoTypeOption('뮤직플레이');
    }, []);

    useEffect(() => {
        setMyVideos(vId === 'none' || vId === null ? [] : [{ videoId: '' }]);
        setMyLectures(vId === 'none' || vId === null ? [] : [{ title: '' }]);
        if (vId) {
            dispatch(getPaidVideos());
            dispatch(getFreeVideos());
            dispatch(getAfterSchoolVideo(vId));
            dispatch(getAfterSchoolLecture(vId));
        }
    }, [dispatch, vId]);

    useEffect(() => {
        if (videos && freeVideos) {
            const newVs = [...videos.filter((v) => v.productGroupId !== 'musicgogoPremium'), ...freeVideos];
            setOptions(newVs);
        }
    }, [videos, freeVideos]);

    useEffect(() => {
        if (afterSchoolVideos) {
            setMyVideos(afterSchoolVideos);
        }
    }, [afterSchoolVideos]);

    useEffect(() => {
        if (afterSchoolLectures) {
            setMyLectures(afterSchoolLectures);
        }
    }, [afterSchoolLectures]);

    const handleClose = () => {
        setOpen(false);
        setMyVideos([]);
        dispatch(clearAfterSchoolVideo());
        setMyLectures([]);
        dispatch(clearAfterSchoolLecture());
        setTypeOption(null);
        setVId(null);
    };

    const handleSaveVideos = () => {
        if (videoTypeOption === '자격증영상') {
            // 별도 DB 사용
            const validLecs = myLectures.filter((l) => (l.hasVideo ==="noVideo") || l?.url.trim() !== '');
            if (validLecs.length === 0) {
                alert('정보를 입력해주세요');
            } else if (validLecs.filter((l) => l.url.trim() === '' && l?.hasVideo ==="hasVideo").length > 0) {
                alert('영상 주소를 입력하지 않은 라인이 있습니다.');
            } else {
                const conf = window.confirm(`${validLecs.length} 개의 영상이 선택되었습니다. 저장하시겠습니까?`);
                if (conf) {
                    const args = {
                        id: vId,
                        lectures: myLectures.map((l) => `${l.url}|${l.title}|${l.subTitle}|${l.end}|${l.hasVideo}`),
                    };
                    dispatch(updateAfterSchoolLectures(args));
                }
            }
        } else {
            // 뮤직플레이 영상 (구독|방과후|뮤직플레이)
            const ids = myVideos.map((v) => v.videoId);
            if (ids.length === 0) {
                alert('선택된 영상이 없습니다.');
            } else if (ids.includes('')) {
                alert('빈 영상은 사용할 수 없습니다. 제거바랍니다.');
            } else {
                const conf = window.confirm(`${ids.length} 개의 영상이 선택되었습니다. 저장하시겠습니까?`);
                if (conf) {
                    const args = {
                        id: vId, // 변경된 아이디
                        videos: ids,
                    };

                    dispatch(updateAfterSchoolVideos(args));
                    setOpen(false);
                }
            }
        }
    };
    const handleAdd = (index) => {
        setMyVideos((prev) => [...prev.slice(0, index + 1), { videoId: '' }, ...prev.slice(index + 1)]);
    };
    const handleDelete = (index) => {
        let newVideos = JSON.parse(JSON.stringify(myVideos));
        if (newVideos.length === 1 && newVideos[0].videoId === '') {
            alert('삭제할 영상이 없습니다.');
            return;
        } else if (newVideos.length === 1) {
            newVideos.splice(index, 1);
            setMyVideos([{ videoId: '' }]);
        } else {
            newVideos.splice(index, 1);
            setMyVideos(newVideos);
        }
    };

    const handleSearch = (index) => {
        setSearchOpen(true);
        setSelectedIndex(index);
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <Box style={{ padding: 15 }}>
                <Typography variant="h4" gutterBottom>
                    제공 영상 관리
                </Typography>
                <Typography variant="caption">* 검색 아이콘을 눌러 영상을 검색하시기 바랍니다</Typography>
                <Typography variant="caption"> - 정렬은 수업영상의 순번 순서입니다. 실시간 반영됩니다</Typography>
            </Box>
            <DialogContent style={{ minHeight: 400 }}>
                {(dataLoading || adminLoading) && <CenterLoading />}
                {dataErrors && <Typography>{dataErrors.errors}</Typography>}
                <Box style={{ marginBottom: 10 }}>
                    {type === 'certificate' ? (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                my: 1,
                            }}
                        >
                            <Box sx={{ flexBasis: '150px' }}>
                                <Typography style={{ fontSize: '16px', fontWeight: 500 }}>차수 선택*</Typography>
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <TextField
                                    select //
                                    fullWidth
                                    variant="outlined"
                                    // color="secondary"
                                    size="small"
                                    margin="dense"
                                    value={vId || 'none'}
                                    onChange={(e) => {
                                        setVId(e.target.value);
                                    }}
                                >
                                    <MenuItem value="none">선택하세요</MenuItem>
                                    {afterSchoolInfo.map((aInfo) => (
                                        <MenuItem key={aInfo.afterschoolVideoId} value={aInfo?.afterschoolVideoId}>
                                            {aInfo?.title}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Box>
                        </Box>
                    ) : (
                        <Box display="flex" alignItems="center" flexDirection="row">
                            <FormLabel component="legend" style={{ marginRight: '20px' }}>
                                유형선택
                            </FormLabel>
                            <RadioGroup value={typeOption} onChange={(e) => setTypeOption(e.target.value)} row>
                                <FormControlLabel value="방과후" label="방과후" control={<Radio color="primary" />} />
                                <FormControlLabel value="구독" label="구독" control={<Radio color="primary" />} />
                            </RadioGroup>
                        </Box>
                    )}
                    <Divider light />
                    {/* 종류 */}
                    {type === 'certificate' && (
                        <RadioGroup value={videoTypeOption} onChange={(e) => setVideoTypeOption(e.target.value)} row>
                            <FormControlLabel
                                value="뮤직플레이"
                                label="뮤직플레이"
                                control={<Radio color="primary" />}
                            />
                            <FormControlLabel
                                value="자격증영상"
                                label="자격증영상"
                                control={<Radio color="primary" />}
                            />
                        </RadioGroup>
                    )}
                    {/* 자격증 영상 */}
                    {videoTypeOption === '자격증영상' && type === 'certificate' ? (
                        <Box>
                            {myLectures.map((lecture, lIndex) => (
                                <LectureLine
                                    key={'lec_' + lIndex}
                                    {...{ lecture, lIndex, myLectures, setMyLectures }}
                                />
                            ))}
                        </Box>
                    ) : (
                        <Box>
                            {myVideos
                                .sort((a, b) => Number(a.order) - Number(b.order))
                                .map((ai, index) => (
                                    <Box
                                        key={ai ? ai.videoId + '-' + index : 'no_' + index}
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                    >
                                        <TextField
                                            value={ai.videoName}
                                            variant="outlined"
                                            size="small"
                                            margin="dense"
                                            style={{ width: 250, backgroundColor: '#FAF3E7' }}
                                        />
                                        {/* search */}
                                        <IconButton
                                            size="small"
                                            style={{ marginLeft: 15 }}
                                            onClick={() => handleSearch(index)}
                                        >
                                            <SearchRounded color="primary" />
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            style={{ marginLeft: 10 }}
                                            onClick={() => handleAdd(index)}
                                        >
                                            <AddRounded color="primary" />
                                        </IconButton>

                                        <IconButton
                                            size="small"
                                            style={{ marginLeft: 10 }}
                                            onClick={() => handleDelete(index)}
                                        >
                                            <RemoveRounded color="primary" />
                                        </IconButton>
                                    </Box>
                                ))}
                        </Box>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="primary" startIcon={<CancelRounded />} onClick={handleClose}>
                    닫기
                </Button>
                <Button variant="contained" color="primary" startIcon={<SaveRounded />} onClick={handleSaveVideos}>
                    저장
                </Button>
            </DialogActions>

            {/* search Dialog */}
            <SearchDialog
                {...{
                    searchOpen,
                    setSearchOpen,
                    selectedIndex,
                    options,
                    myVideos,
                    setMyVideos,
                }}
            />
        </Dialog>
    );
}

/* Search Dialog */

function SearchDialog({ searchOpen, setSearchOpen, selectedIndex, options, myVideos, setMyVideos }) {
    const [checked, setChecked] = useState(null);
    const handleClose = () => {
        setSearchOpen(false);
        setChecked(null);
    };
    const handleSave = () => {
        if (checked) {
            const isDup = myVideos.filter((v) => v.videoId === checked.videoId).length > 0;
            if (isDup) {
                alert('이미 선택된 영상입니다.');
            } else {
                setMyVideos(myVideos.map((v, i) => (i === selectedIndex ? checked : v)));
                setSearchOpen(false);
                setChecked(null);
            }
        } else {
            alert('항목을 선택해주세요.');
        }
    };
    return (
        <Dialog open={searchOpen} onClose={handleClose} fullWidth maxWidth="xs">
            <DialogContent>
                <Typography gutterBottom variant="h5">
                    영상이름으로 검색
                </Typography>
                <Box style={{ width: 300 }}>
                    <Autocomplete
                        options={options.sort((a, b) => (a?.videoName > b?.videoName ? 1 : -1))}
                        getOptionLabel={(option) => option?.videoName}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" margin="dense" size="small" />
                        )}
                        renderOption={(option) => (
                            <Box style={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography>{option?.videoName}</Typography>
                                <Typography variant="caption">
                                    {option?.category} - {option?.productGroupId}
                                </Typography>
                            </Box>
                        )}
                        value={checked}
                        onChange={(e, newVal) => {
                            setChecked(newVal);
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="primary" onClick={handleClose}>
                    닫기
                </Button>
                <Button variant="contained" color="primary" onClick={handleSave}>
                    적용
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function LectureLine({ lecture, lIndex, myLectures, setMyLectures }) {
    const [detailOpen, setDetailOpen] = useState(false);
    const newLine = {
        title: '',
        subTitle: '',
        end: '',
        url: '',
    };
    const [detailInfo, setDetailInfo] = useState(newLine);
    const handleAddLine = () => {
        setMyLectures((prev) => [...prev, newLine]);
    };
    const handleDeleteLine = (index) => {
        let newLectures = JSON.parse(JSON.stringify(myLectures));
        if (newLectures.length === 1 && newLectures[0].title === '') {
            alert('삭제할 영상이 없습니다.');
            return;
        } else if (newLectures.length === 1) {
            newLectures.splice(index, 1);
            setMyLectures([{ title: '' }]);
        } else {
            newLectures.splice(index, 1);
            setMyLectures(newLectures);
        }
    };
    return (
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
            <Box display="flex" flexDirection="row" alignItems="center">
                <TextField
                    variant="outlined"
                    size="small"
                    margin="dense"
                    value={lecture?.title}
                    InputProps={{
                        readOnly: true,
                    }}
                    style={{ width: 250, backgroundColor: '#FAF3E7' }}
                />
                <IconButton
                    size="small"
                    style={{ marginLeft: 10 }}
                    onClick={() => {
                        setDetailOpen(true);
                        setDetailInfo(myLectures[lIndex]);
                    }}
                >
                    <DescriptionRounded color="primary" />
                </IconButton>
            </Box>
            <Box>
                <IconButton size="small" style={{ marginLeft: 10 }} onClick={() => handleDeleteLine(lIndex)}>
                    <RemoveRounded color="primary" />
                </IconButton>

                <IconButton size="small" style={{ marginLeft: 10 }} onClick={() => handleAddLine(lIndex)}>
                    <AddRounded color="primary" />
                </IconButton>
            </Box>
            <DetailDialog {...{ detailOpen, setDetailOpen, detailInfo, setMyLectures, lIndex }} />
        </Box>
    );
}

function DetailDialog({ detailOpen, setDetailOpen, detailInfo, setMyLectures, lIndex }) {
    const [title, setTitle] = useState('');
    const [subTitle, setSubTitle] = useState('');
    const [url, setUrl] = useState('');
    const [end, setEnd] = useState('');
    const [hasVideo, setHasVideo] = useState('hasVideo');
    useEffect(() => {
        setTitle(detailInfo?.title || '');
        setSubTitle(detailInfo?.subTitle || '');
        setUrl(detailInfo?.url);
        setEnd(detailInfo?.end);
        setHasVideo(detailInfo?.hasVideo || 'hasVideo');
    }, [detailInfo]);

    const handleCloseD = () => {
        setDetailOpen(false);
    };
    const handleSaveLectures = () => {
        if (title.trim() === '' || (url.trim() === '' && hasVideo === 'hasVideo')) {
            alert('정보를 입력해주세요');
        } else {
            setMyLectures((prev) => {
                let newLectures = [...prev];
                newLectures[lIndex] = { title, subTitle, end, url, hasVideo };
                return newLectures;
            });
            setDetailOpen(false);
        }
    };
    return (
        <Dialog open={detailOpen} onClose={handleCloseD} maxWidth="xs">
            <DialogTitle>상세 영상 정보</DialogTitle>

            <DialogContent>
                <TextField
                    variant="outlined"
                    fullWidth
                    size="small"
                    margin="dense"
                    label="영상 제목"
                    name="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    style={{ backgroundColor: '#FAF3E7' }}
                />
                <TextField
                    variant="outlined"
                    fullWidth
                    size="small"
                    margin="dense"
                    label="[부제목]"
                    name="subTitle"
                    value={subTitle}
                    onChange={(e) => setSubTitle(e.target.value)}
                    style={{ backgroundColor: '#FAF3E7' }}
                />
                <RadioGroup row>
                    <FormControlLabel
                        value="hasVideo"
                        control={<Radio color="primary" />}
                        label="영상있음"
                        checked={hasVideo === 'hasVideo'}
                        onChange={(e) => setHasVideo(e.target.value)}
                    />
                    <FormControlLabel
                        value="noVideo"
                        control={<Radio color="primary" />}
                        label="영상준비중"
                        checked={hasVideo === 'noVideo'}
                        onChange={(e) => setHasVideo(e.target.value)}
                    />
                </RadioGroup>
                <TextField
                    variant="outlined"
                    fullWidth
                    size="small"
                    margin="dense"
                    label="영상주소(vimeo url)"
                    name="url"
                    placeholder="영상주소"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    style={{ backgroundColor: '#FAF3E7' }}
                />
                <Box>
                    <Typography gutterBottom variant="body2">
                        * Vimeo 영상 업로드 후, 좌측 '디자인' 버튼을 눌러, 임베드 사전설정에 '로그저장용 설정' 을 반드시
                        설정하기 바랍니다. 영상 앞으로 건너뛰기 등을 막는 설정이 되어 있습니다.
                    </Typography>
                </Box>
                <TextField
                    variant="outlined"
                    fullWidth
                    size="small"
                    margin="dense"
                    type="date"
                    label="종료일까지 재생"
                    name="end"
                    value={end}
                    onChange={(e) => setEnd(e.target.value)}
                    style={{ backgroundColor: '#FAF3E7' }}
                />
                <Box>
                    <Typography gutterBottom variant="body2">
                        * 입력하지 않으면, 과정종료일까지 공개되며, 특정 종료일을 위와 같이 지정할 수 있습니다.
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseD}>닫기</Button>
                <Button variant="outlined" color="primary" startIcon={<SaveRounded />} onClick={handleSaveLectures}>
                    저장
                </Button>
            </DialogActions>
        </Dialog>
    );
}
